"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _FirstPage = _interopRequireDefault(require("@material-ui/icons/FirstPage"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _LastPage = _interopRequireDefault(require("@material-ui/icons/LastPage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;
  return {
    root: (_root = {
      flexShrink: 0
    }, _defineProperty(_root, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(2.5)
    }), _defineProperty(_root, '& button', {
      padding: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }), _root)
  };
});
SttTablePaginationActions.propTypes = {
  count: _propTypes["default"].number.isRequired,
  onPageChange: _propTypes["default"].func.isRequired,
  page: _propTypes["default"].number.isRequired,
  rowsPerPage: _propTypes["default"].number.isRequired
};
function SttTablePaginationActions(props) {
  var classes = useStyles();
  var count = props.count,
    page = props.page,
    rowsPerPage = props.rowsPerPage,
    onPageChange = props.onPageChange;
  var handleFirstPageButtonClick = function handleFirstPageButtonClick(event) {
    onPageChange(event, 0);
  };
  var handleBackButtonClick = function handleBackButtonClick(event) {
    onPageChange(event, page - 1);
  };
  var handleNextButtonClick = function handleNextButtonClick(event) {
    onPageChange(event, page + 1);
  };
  var handleLastPageButtonClick = function handleLastPageButtonClick(event) {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: handleFirstPageButtonClick,
    disabled: page === 0
  }, /*#__PURE__*/_react["default"].createElement(_FirstPage["default"], null)), " ", /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: handleBackButtonClick,
    disabled: page === 0
  }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], null)), " ", /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: handleNextButtonClick,
    disabled: count === -1 ? false : page >= Math.ceil(count / rowsPerPage) - 1
  }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowRight["default"], null)), " ", /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: handleLastPageButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    style: {
      display: count === -1 ? 'none' : 'inline-flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_LastPage["default"], null)), " ");
}
var _default = SttTablePaginationActions;
exports["default"] = _default;